import { connect } from 'react-redux';
import { submit } from 'redux-form';
import subPage from 'decorators/subPage';
import { activateSub } from 'actions/subs';
import { getSubmitStatus, getActivationResponse } from 'reducers';
import { generatePinSync as generatePin } from 'secure-pin';
import ActivationForm from 'components/ActivationForm';

const pin = generatePin(4);

const mapStateToProps = (state, { subId }) => ({
  initialValues: { pin },
  saveStatus: getSubmitStatus(state, 'activateSub'),
  activationResponse: getActivationResponse(state, subId),
});

const mapDispatchToProps = (dispatch, { subId }) => ({
  onSubmit: (values) => dispatch(activateSub(subId, values)),
  remoteSubmit: () => dispatch(submit('activateSub')),
});

export default subPage(
  connect(mapStateToProps, mapDispatchToProps)(ActivationForm),
);
